var crateNumber = 3;
var variantTitle = 'Youth Medium'
class giftSubscription {
    constructor(){
        document.querySelectorAll("[data-select-gift]").forEach(ele=>{
            ele.addEventListener("change" , (event)=>{
                this._chooseCrateNumber(event);
            })
        });
        document.querySelectorAll("[data-select-size]").forEach(ele=>{
            ele.addEventListener("change" , (event)=>{
                this._chooseShirtSize(event);
            })
        });

        document.querySelector("[data-atc-btn]").addEventListener("click",(event)=>{
            
            this._addToCart(event);
        })

    }
    _chooseCrateNumber(event){
        let currentEle = event.currentTarget;
        crateNumber = parseInt(currentEle.options[currentEle.selectedIndex].getAttribute("data-crate-number"));
        let discount = parseInt(currentEle.options[currentEle.selectedIndex].getAttribute("data-discount"));
        let subTotal = currentEle.options[currentEle.selectedIndex].getAttribute("data-price");
        document.querySelector("[gift_sub_total]").innerHTML = subTotal;
        let unitPrice = currentEle.options[currentEle.selectedIndex].getAttribute("product_unit_price");
        document.querySelector("[gift_price]").innerHTML = unitPrice;
        if (discount == 0 ) {
            document.querySelector("[total_discount]").innerHTML = 'no saving';
            document.querySelector("[total_discount]").classList.remove("savings");
        }else{
            document.querySelector("[total_discount]").innerHTML = `save ${discount}%`;
            document.querySelector("[total_discount]").classList.add("savings");
        }
    };

    _chooseShirtSize(event){
        let currentEle = event.currentTarget;
        variantTitle = currentEle.value;
    };

   async _addToCart(event){
        event.stopImmediatePropagation();
     
        event.currentTarget.classList.add("loading");
        let variantId;
        let subscription_Id;
        let flag = false;
        let selling_plan_id;
        let items = [];
        document.querySelectorAll("[data-main-product-variant]").forEach(ele=>{
           let crateNum = parseInt(ele.getAttribute("data-crate-ship"));
           if (crateNum == crateNumber && flag == false) {
            let mainProductData = JSON.parse(ele.innerText);
              mainProductData = mainProductData.find(x=> x.variant_title == variantTitle);
              //variantId = parseInt(mainProductData.subscription_varint_id);
              variantId = parseInt(mainProductData.variant_id);
              subscription_Id = parseInt(mainProductData.subscription_id);
              selling_plan_id = parseInt(mainProductData.selling_plan_id);
              flag = true;
        let subscriptionData = {};
        // subscriptionData['shipping_interval_frequency'] = '1';
        // subscriptionData['shipping_interval_unit_type'] = "month";
        // subscriptionData['subscription_id'] = `${subscription_Id}`;
        subscriptionData['No of Crate'] = `${crateNumber}`;
             subscriptionData['is_subscrption'] = true; 


    
        items.push({
            quantity: 1,
            id: parseInt(variantId),
            properties: subscriptionData,
            selling_plan : selling_plan_id
          });

          var requestData = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({items: items}),
        };
          fetch('/cart/add.js', requestData)
          .then(async data => {
              let currentEle = document.querySelector("[data-submit-subscription]");
              currentEle.classList.remove("loading");
              window.location.href = "/cart";
          }).catch(e => {
              let currentEle = document.querySelector("[data-submit-subscription]");
              currentEle.classList.remove("loading");
          });

        }
    });


    }
  }
  new giftSubscription();

